import { SortOrder } from "@towersystems/roam-common/lib/generated-types";

export const NO_RESULTS_LABEL = "No serial numbers to show";

export const DEFAULT_QUERY_OPTIONS = {
  limit: 999,
  sort: {
    value: SortOrder.ASC,
  },
} as const;
